<template>
  <i-menu class="contract-menu" mode="horizontal" theme="dark">
    <!-- <router-link
      class="ivu-menu-item contract-menu__contract-name"
      :to="backPath"
      exact
    >
      <icon size="24" type="ios-arrow-back" />
    </router-link> -->
    <div
      class="ivu-menu-item back-button contract-menu__contract-name"
      @click="back"
    >
      <icon size="24" type="ios-arrow-back" />
    </div>
    <router-link
      v-for="link in filteredMainLinks"
      :key="link.id"
      class="ivu-menu-item"
      :to="`/app/contracts/${id}/${link.path}`"
    >
      {{ link.name }}
    </router-link>

    <submenu v-if="filteredSecondaryLinks.length" name="4">
      <template slot="title">Еще</template>
      <router-link
        v-for="link in filteredSecondaryLinks"
        :key="link.id"
        class="ivu-menu-item"
        :to="link.path"
      >
        {{ link.name }}
      </router-link>
    </submenu>
  </i-menu>
</template>

<script>
const mainContractLinks = [
  {
    id: 'overview',
    path: 'overview',
    name: 'Общее',
    free: true
  },
  {
    id: 'time-table',
    path: 'time-table',
    name: 'План-график',
    free: false
  },
  {
    id: 'contract_register',
    path: 'register',
    name: 'Реестр',
    free: false
  },
  {
    id: 'amendments',
    path: 'amendments',
    name: 'ДС',
    free: false
  },
  {
    id: 'contragents',
    path: 'contragents',
    name: 'Подрядчики',
    free: false
  },
  {
    id: 'contract_acts',
    path: 'acts',
    name: 'Акты',
    free: false
  },
  {
    id: 'contract_payments',
    path: 'payments',
    name: 'Платежи',
    free: false
  },
  {
    id: 'resources',
    path: 'resources',
    name: 'Материалы',
    free: true
  },
  {
    id: 'bgs',
    path: 'bgs',
    name: 'БГ',
    free: true
  }
]
const secondaryContractLinks = [
  {
    id: 'law_cases',
    path: 'law-cases',
    name: 'Судебные дела',
    free: false
  },
  {
    id: 'conclusions',
    path: 'conclusions',
    name: 'Отзывы',
    free: true
  },
  {
    id: 'expertises',
    path: 'expertises',
    name: 'Заключения экспертизы',
    free: true
  }
]

export default {
  data () {
    return {
      prevRoute: ''
    }
  },
  computed: {
    id () {
      return this.$route.params.id
    },
    backPath () {
      const { comeFrom } = this.$store.state.contracts

      if (comeFrom) return `/app/${comeFrom}`

      return '/app/contracts'
    },
    filteredMainLinks () {
      return mainContractLinks.filter((l) => {
        if (l.free) return true

        return this.$store.getters.hasModule(l.id)
      })
    },
    filteredSecondaryLinks () {
      return secondaryContractLinks.filter((l) => {
        if (l.free) return true

        return this.$store.getters.hasModule(l.id)
      })
    },
    isBackAvailable () {
      return this.prevRoute !== this.$route.name
    }
  },
  methods: {
    back () {
      if (!this.isBackAvailable) {
        return this.$router.push('/app/contracts')
      }

      this.prevRoute = this.$route.name

      this.$router.back()
    }
  },
  created () {
    this.prevRoute = this.$route.name
  }
}
</script>

<style lang="less">
.contract-menu {
  &.ivu-menu {
    z-index: 400;
  }

  &.ivu-menu-horizontal {
    .ivu-menu-item {
      padding: 0 10px;

      &.back-button {
        padding-left: 0;
      }
    }
  }

  &__contract-name {
    max-width: 112px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .ivu-menu-submenu {
    padding: 0 12px;
    z-index: 1000;

    .ivu-select-dropdown {
      z-index: 1000;

      .ivu-menu-item {
        font-size: 12px !important;

        &:first-child {
          padding-left: 16px;
        }
      }
    }
  }
}
</style>
